import { render, staticRenderFns } from "./NewDocumentRelated.vue?vue&type=template&id=4f971016&scoped=true&"
import script from "./NewDocumentRelated.vue?vue&type=script&lang=js&"
export * from "./NewDocumentRelated.vue?vue&type=script&lang=js&"
import style0 from "./NewDocumentRelated.vue?vue&type=style&index=0&id=4f971016&scoped=true&lang=css&"
import style1 from "./NewDocumentRelated.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f971016",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f971016')) {
      api.createRecord('4f971016', component.options)
    } else {
      api.reload('4f971016', component.options)
    }
    module.hot.accept("./NewDocumentRelated.vue?vue&type=template&id=4f971016&scoped=true&", function () {
      api.rerender('4f971016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Invoices/NewDocumentRelated/NewDocumentRelated.vue"
export default component.exports